import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core'
import { NavigationEnd, Router, RouterModule } from '@angular/router'
import { Footer2Component } from '../../components/footer2/footer2.component'
import { filter, map, startWith } from 'rxjs/operators'
import { toSignal } from '@angular/core/rxjs-interop'

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [RouterModule, Footer2Component],
  templateUrl: './auth-layout.component.html',
  styles: ``,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AuthLayoutComponent {
  private readonly router = inject(Router)

  readonly useShellLayout = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(() => this.isShellRoute()),
      startWith(this.isShellRoute()),
    ),
    { initialValue: this.isShellRoute() },
  )

  private isShellRoute(): boolean {
    const url = this.router.url
    return url.includes('/auth/login') || url.includes('/auth/forgot-password')
  }
}
